import { IBaseAction } from '@models/actions/IBaseAction';
import { IActionExecutor } from '@organisms/actions/IActionExecutor';
import { FilesService } from '@services/FilesService';

export class DownloadExecutor implements IActionExecutor {
    run = (
        objId: string,
        parentId: string | undefined,
        _action: IBaseAction,
        _rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
    ) => {
        // Действие завершается, когда файл получен; отказ FilesService уже показал тостом с причиной.
        void FilesService.downloadFile(`attachment/download/${parentId}/${objId}`)
            .catch(() => undefined)
            .finally(() => completeHandler?.(false));
    };
}
